import script from "./FiltersPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltersPagination.vue?vue&type=script&setup=true&lang=js"

import "./FiltersPagination.vue?vue&type=style&index=0&id=23cf26fb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23cf26fb"]])

export default __exports__